export { default } from './CompareCompany';
